import styles from "./link-cta.module.css";
import { Link } from "~/components/RouterLink";
import type { PropsWithChildren } from "react";
import { Flex } from "@radix-ui/themes";

export function LinkCta({
  to,
  children,
  px,
  py,
  className,
  fitContent = false,
}: PropsWithChildren<{
  to?: string;
  py?: string;
  px?: string;
  className?: string;
  fitContent?: boolean;
}>) {
  const ctaClassName = className
    ? `${styles.linkCta} ${className}`
    : styles.linkCta;
  const sizeProps = fitContent ? {} : { height: "100%", width: "100%" };

  if (to) {
    if (fitContent) {
      return (
        <Link to={to} className={ctaClassName}>
          {children}
        </Link>
      );
    }

    return (
      <Flex
        justify="center"
        align="center"
        px={px}
        py={py}
        {...sizeProps}
        asChild
      >
        <Link to={to} className={ctaClassName}>
          {children}
        </Link>
      </Flex>
    );
  }
  return (
    <Flex
      align="center"
      px={px}
      py={py}
      {...sizeProps}
      className={ctaClassName}
    >
      {children}
    </Flex>
  );
}
